import {
  IonContent,
  IonPage,
  NavContext,
  useIonViewDidEnter,
} from "@ionic/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import plusIcon from "../../assets/images/ic_plus_button_primary_2z.svg";
import nextImg from "../../assets/images/nextz.svg";
import "./index.scss";
import EditAddAddress from "./components/EditAddAddress";
import { CircularProgress, Drawer } from "@mui/material";
import familyPlanServices from "../../services/FamilyPlanServices";
import navigoServices from "../../services/NavigoServices";
import { useHistory, useLocation, withRouter } from "react-router";
import BackButton from "../../components/common/BackButton";
import AuthenticationService from "../../services/AuthenticationService";
import AddressElement from "./components/addressElement";
import RemoveDialog from "./components/removeDialog";
import NoAddressFound from "./components/noAddressFound";
import { useDispatch, useSelector } from "react-redux";
import {
  handleAddressErrorReducer,
  handleEditRemove,
  setStateFromPayloadAddress,
  toggleDisabledAddress,
} from "./addressSlice";
import Toast from "../../components/common/toast";
import { setStateFromPayload } from "../navigo/navigoSlice";
import { setMedicineAddress } from "../medicineOrder/medicineSlice";
import ErrorComponent from "../../components/common/ErrorComponent";
import { allRoutes } from "../../app/list";
import NavigoFinalSection from "../navigo/components/navigoFinalSection";
import { checkConfig } from "../navigo/navigoSlice";
import { Home, MoreVertical } from "lucide-react";

const emptyAddress = {
  city: "",
  countryCode: "91",
  district: "",

  landmark: "",
  line1: "",
  line2: "",
  name: "",

  phoneNo: "",
  pincode: "",
  state: "",
  type: 1,
};

export default function AddressBook({
  booking: booking,
  service: service,
  price: price,
  memberRelation: memberRelation,
  familyMember: familyMember,
}) {
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile
  );

  const addressStore = useSelector((store) => store.address);

  const toastTimer = useRef(null);
  const addressToRemove = useRef();
  const indexOfAddressToRemove = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const navContext = useContext(NavContext);
  const [navigoFinalSection, setNavigoFinalSection] = useState(false);
  const [choosedAddress, setChoosedAddress] = useState(null);
  // Standalone Address book: open triple-dot menu + first-enter guard for the
  // refresh-on-return.
  const [menuOpenId, setMenuOpenId] = useState(null);
  const hasEnteredRef = useRef(false);
  const menuRef = useRef(null);
  const tripleDotRef = useRef(null);
  const {
    layout,
    loading,
    memberData,
    memberPatientId,
    addressbook,
    editRemoveIndex,
    openRemoveDialog,
    showToast,
    buttonMsg,
    selectedAddress,
    isEdit,
    selectMedicineOrderAddress,
    disabledDeliveryAddress,
    defaultLayout,
    error,
    errorMsg,
  } = addressStore;

  useEffect(() => {
    const { state } = location;
    let id = -1;
    let memberData = {};

    if (state && state.isMember) {
      id = state.memberPatientId;

      memberData = { ...state.memberData };
    }
    if (
      memberData &&
      memberData.countryCode &&
      memberData.countryCode != "91"
    ) {
      // history.replace("/tab/chat");
      navContext.goBack("/tab/chat");
    } else {
      {
        dispatch(
          setStateFromPayloadAddress({
            loading: true,
          })
        );
        familyPlanServices
          .getAllAddress(id)
          .then((result) => {
            const res = result.data;
            let layout = 1;
            let defLayout = 1;
            let path = "";
            let btnMsg = "Deliver to this address";
            if (state && state.isPath) {
              defLayout = 4;
              layout = 4;
              path = state.path;
              if (state.path === "/navigo") {
                btnMsg = "Continue";
              }
            }
            let myAddresses = [];
            if (res && res.length === 0) {
              layout = 2;
            }

            if (res && res.length > 0) {
              myAddresses = [...res];
            }
            dispatch(
              setStateFromPayloadAddress({
                loading: false,
                layout: layout,
                defaultLayout: defLayout,
                addressbook: [...myAddresses],
                memberPatientId: id,
                memberData: memberData,
                path: path,
                buttonMsg: btnMsg,
                disabledDeliveryAddress: true,
                selectMedicineOrderAddress: -1,
              })
            );
          })
          .catch((err) => {
            dispatch(
              setStateFromPayloadAddress({
                loading: false,
                error: true,
                errorMsg: "Error while fetching address",
              })
            );
          });
      }
    }
    return () => {
      if (toastTimer.current) {
        clearTimeout(toastTimer.current);
      }
    };
  }, [location.state]);

  // Close the address card's Edit/Remove menu when clicking outside it.
  useEffect(() => {
    if (menuOpenId == null) return undefined;
    const handler = (e) => {
      const inMenu = menuRef.current?.contains(e.target);
      const inButton = tripleDotRef.current?.contains(e.target);
      if (!inMenu && !inButton) setMenuOpenId(null);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [menuOpenId]);

  useIonViewDidEnter(() => {
    dispatch(handleEditRemove(-1));
    // Refresh the standalone Address book after returning from Add/Edit
    // (the location.state effect doesn't re-fire on a back navigation). Skip
    // the first enter (the initial load handles it), and only for the
    // standalone management view so the medicine/booking pickers are untouched.
    if (!hasEnteredRef.current) {
      hasEnteredRef.current = true;
      return;
    }
    if (defaultLayout === 1 && !booking) {
      familyPlanServices
        .getAllAddress(memberPatientId)
        .then((result) => {
          const res = Array.isArray(result?.data) ? result.data : [];
          dispatch(
            setStateFromPayloadAddress({
              addressbook: [...res],
              layout: res.length === 0 ? 2 : 1,
            }),
          );
        })
        .catch(() => {});
    }
  }, [defaultLayout, booking, memberPatientId]);

  const handleAddressAddition = () => {
    let userName = "";
    let phoneNo = "";
    let countryCode = "91";

    if (patientProfile) {
      userName = patientProfile.firstName + " " + patientProfile.lastName;
      phoneNo = patientProfile.phoneno;
      countryCode = patientProfile.countryCode;
    }
    if (memberPatientId !== -1) {
      phoneNo = memberData.phoneNo;
      if (
        memberData &&
        (memberData.relation === 6 || memberData.relation === 8)
      ) {
        phoneNo = patientProfile?.phoneno;
      }
      userName =
        memberData.firstName +
        " " +
        `${memberData.lastName ? memberData.lastName : ""}`;
      countryCode = memberData.countryCode;
    }

    dispatch(
      setStateFromPayloadAddress({
        layout: 3,
        isEdit: false,
        selectedAddress: {
          ...emptyAddress,
          name: userName,
          phoneNo: phoneNo,
          countryCode: countryCode,
        },
      })
    );
  };
  const handleDrawerClose = (arg, data) => {
    if (arg) {
      let newAddressList = [];
      if (isEdit) {
        newAddressList = addressbook.map((addr) => {
          if (addr.id === data.id) {
            return { ...data };
          }
          return { ...addr };
        });
      } else {
        if (addressbook && addressbook.length > 0) {
          newAddressList = addressbook.map((addr) => addr);
        }
        newAddressList.push({ ...data });
      }
      dispatch(
        setStateFromPayloadAddress({
          addressbook: [...newAddressList],
          layout: defaultLayout,
        })
      );
    } else {
      dispatch(
        setStateFromPayloadAddress({
          layout: addressbook.length > 0 ? defaultLayout : 2,
        })
      );
    }
  };

  const handleOpenRemoveDialog = (arg, addr) => {
    dispatch(
      setStateFromPayloadAddress({
        openRemoveDialog: arg,
        editRemoveIndex: -1,
        addressToRemove: arg ? { ...addr } : {},
      })
    );
  };
  const handleMedicineOrder = () => {
    let selectedAddress = addressbook[selectMedicineOrderAddress];
    const { state } = location;

    const {
      isMedicine,
      path,
      serviceId,
      memberPatientId,
      memberData,
      isMember,
      isUserSelectedFamily,
    } = state;

    if (isMedicine) {
      dispatch(setMedicineAddress({ address: { ...selectedAddress } }));
      navContext.navigate(
        `${path}?isFamily=${isMember}&memberPatientId=${memberPatientId}&isAddr=true`,
        "none",
        "pop"
      );
    } else {
      dispatch(
        setStateFromPayloadAddress({
          disabledDeliveryAddress: false,
          loading: true,
        })
      );
      navigoServices
        .checkServiceAvailability({
          serviceId: serviceId,
          addressId: selectedAddress.id,
        })
        .then((result) => {
          let res = result.data;
          if (res && res.serviceable) {
            dispatch(
              setStateFromPayload({ addressSelected: { ...selectedAddress } })
            );

            navContext.navigate(
              `${path}?isFamily=${isMember}&memberPatientId=${memberPatientId}&isUserSelectedFamily=${isUserSelectedFamily}`,
              "none",
              "pop"
            );
          } else {
            dispatch(
              handleAddressErrorReducer({
                err: true,
                errMsg:
                  "Location is non-serviceable.Please select a different address",
              })
            );
          }
        })
        .catch((err) => {
          dispatch(
            handleAddressErrorReducer({
              err: true,
              errMsg:
                "Location is non-serviceable.Please select a different address",
            })
          );
        });
    }
  };
  const handleBooking = () => {
    let selectedAddress = addressbook[selectMedicineOrderAddress];
    const { state } = location;
    setChoosedAddress(selectedAddress.id);

    // const {
    //   isMedicine,
    //   path,
    //   serviceId,
    //   memberPatientId,
    //   memberData,
    //   isMember,
    //   isUserSelectedFamily,
    // } = state;

    if (!booking) {
      // dispatch(setMedicineAddress({ address: { ...selectedAddress } }));
      // navContext.navigate(
      //   `${path}?isFamily=${isMember}&memberPatientId=${memberPatientId}&isAddr=true`,
      //   "none",
      //   "pop"
      // );
    } else {
      dispatch(
        setStateFromPayloadAddress({
          disabledDeliveryAddress: false,
          loading: true,
        })
      );
      dispatch(
        checkConfig({ patientId: patientProfile.id, planId: service.planId })
      );
      navigoServices
        .checkServiceAvailability({
          serviceId: service.serviceId,
          addressId: selectedAddress.id,
        })
        .then((result) => {
          let res = result.data;
          if (res && res.serviceable) {
            dispatch(
              setStateFromPayload({ addressSelected: { ...selectedAddress } })
            );
            setNavigoFinalSection(true);
          } else {
            dispatch(
              handleAddressErrorReducer({
                err: true,
                errMsg:
                  "Location is non-serviceable.Please select a different address",
              })
            );
          }
        })
        .catch((err) => {
          dispatch(
            handleAddressErrorReducer({
              err: true,
              errMsg:
                "Location is non-serviceable.Please select a different address",
            })
          );
        });
    }
  };

  return (
    <IonPage>
      <IonContent className="address-book-ion-content-class">
        {navigoFinalSection ? (
          <NavigoFinalSection
            memberRelation={memberRelation}
            service={service}
            price={price}
            addressId={choosedAddress}
            familyMember={familyMember}
          />
        ) : (
          <>
            {error && (
              <ErrorComponent
                show={error}
                msg={errorMsg}
                errorClose={() => {
                  dispatch(
                    handleAddressErrorReducer({ err: false, errMsg: "" })
                  );
                }}
              />
            )}
            {editRemoveIndex != -1 && (
              <div
                className="fixed w-screen h-screen bg-transparent z-9"
                onClick={() => {
                  dispatch(handleEditRemove());
                }}
              ></div>
            )}
            <div className="address-book-container">
              {(layout === 1 || layout === 2 || layout === 4 || booking) && (
                <div className="address-book-header">
                  <BackButton />
                  <p>Address book</p>
                </div>
              )}
              {loading && (
                <CircularProgress className="address-book-loading-circular"></CircularProgress>
              )}

              {!loading && layout === 1 && !booking && (
                <div className="address-book-main">
                  <div
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      padding: "8px 4px 96px",
                    }}
                  >
                    {addressbook.map((addr) => {
                      const needsUpdate =
                        !addr.coordinates ||
                        (addr.coordinates.latitude === 0 &&
                          addr.coordinates.longitude === 0);
                      return (
                      <div
                        key={addr.id}
                        style={{
                          position: "relative",
                          display: "flex",
                          gap: 14,
                          padding: 14,
                          marginBottom: 12,
                          border: "1px solid #E5E7EB",
                          borderRadius: 12,
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <Home
                          size={26}
                          style={{
                            color: "#12194C",
                            flexShrink: 0,
                            marginTop: 2,
                          }}
                        />
                        <div
                          style={{ flex: 1, minWidth: 0, paddingRight: 24 }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              flexWrap: "wrap",
                            }}
                          >
                            <p
                              style={{
                                margin: 0,
                                fontSize: 15,
                                fontWeight: 700,
                                color: "#12194C",
                                wordBreak: "break-word",
                              }}
                            >
                              {addr.name}
                            </p>
                            {needsUpdate && (
                              <span
                                style={{
                                  padding: "3px 10px",
                                  backgroundColor: "#FBE7ED",
                                  color: "#97144D",
                                  borderRadius: 999,
                                  fontSize: 11,
                                  fontWeight: 700,
                                  fontFamily: "'Montserrat', sans-serif",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Update address
                              </span>
                            )}
                          </div>
                          <p
                            style={{
                              margin: "6px 0 8px",
                              fontSize: 13,
                              color: "#374151",
                              lineHeight: 1.45,
                              wordBreak: "break-word",
                            }}
                          >
                            {[addr.line1, addr.line2, addr.landmark]
                              .filter(Boolean)
                              .join(", ")}
                            <br />
                            {[addr.district, addr.city, addr.state]
                              .filter(Boolean)
                              .join(", ")}
                            {addr.pincode ? ` - ${addr.pincode}` : ""}
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: 13,
                              color: "#374151",
                            }}
                          >
                            Phone number- {addr.phoneNo}
                          </p>
                        </div>
                        <button
                          type="button"
                          ref={
                            menuOpenId === addr.id ? tripleDotRef : null
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            setMenuOpenId(
                              menuOpenId === addr.id ? null : addr.id,
                            );
                          }}
                          aria-label="More options"
                          style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            background: "transparent",
                            border: "none",
                            padding: 4,
                            cursor: "pointer",
                            color: "#6B7280",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <MoreVertical size={18} />
                        </button>
                        {menuOpenId === addr.id && (
                          <div
                            ref={menuRef}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              position: "absolute",
                              top: 36,
                              right: 10,
                              backgroundColor: "#FFFFFF",
                              border: "1px solid #E5E7EB",
                              borderRadius: 8,
                              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                              overflow: "hidden",
                              zIndex: 6,
                              minWidth: 120,
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => {
                                setMenuOpenId(null);
                                history.push({
                                  pathname: "/manage-address",
                                  state: { editAddress: { ...addr } },
                                });
                              }}
                              style={{
                                width: "100%",
                                padding: "10px 14px",
                                border: "none",
                                background: "transparent",
                                textAlign: "left",
                                cursor: "pointer",
                                fontSize: 13,
                                fontWeight: 600,
                                color: "#12194C",
                                fontFamily: "'Montserrat', sans-serif",
                              }}
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setMenuOpenId(null);
                                handleOpenRemoveDialog(true, addr);
                              }}
                              style={{
                                width: "100%",
                                padding: "10px 14px",
                                border: "none",
                                borderTop: "1px solid #F1F5F9",
                                background: "transparent",
                                textAlign: "left",
                                cursor: "pointer",
                                fontSize: 13,
                                fontWeight: 600,
                                color: "#B91C1C",
                                fontFamily: "'Montserrat', sans-serif",
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                      );
                    })}
                  </div>

                  <div
                    className="address-book-add-new-item"
                    onClick={() => history.push("/manage-address")}
                  >
                    <img src={plusIcon} alt="icon" />
                  </div>
                </div>
              )}
              {!loading && layout === 2 && (
                <NoAddressFound
                  handleAddressAddition={
                    defaultLayout === 1 && !booking
                      ? () => history.push("/manage-address")
                      : handleAddressAddition
                  }
                />
              )}
              {!loading && layout === 3 && (
                <EditAddAddress handleClose={handleDrawerClose} />
              )}
              {!loading && layout === 4 && (
                <div className="address-book-main">
                  {addressbook.map((addr, index) => {
                    return (
                      <AddressElement
                        key={addr.id}
                        addr={{ ...addr }}
                        index={index}
                        editRemoveIndex={editRemoveIndex}
                        handleOpenRemoveDialog={handleOpenRemoveDialog}
                        selectMedicineOrderAddress={selectMedicineOrderAddress}
                        showRemoveOption={false}
                        isRadio={true}
                      />
                    );
                  })}
                  <div className="address-layout-5-middle">
                    <span>Add a new address</span>
                    <button
                      className="address-layout-5-middle-button"
                      onClick={handleAddressAddition}
                    >
                      <img src={nextImg} />
                    </button>
                  </div>
                  <button
                    className="address-layout-5-bottom"
                    onClick={handleMedicineOrder}
                    disabled={disabledDeliveryAddress}
                  >
                    {buttonMsg}
                  </button>
                </div>
              )}
              {!loading && booking && (
                <div className="address-book-main">
                  {addressbook.map((addr, index) => {
                    return (
                      <AddressElement
                        key={addr.id}
                        addr={{ ...addr }}
                        index={index}
                        editRemoveIndex={editRemoveIndex}
                        handleOpenRemoveDialog={handleOpenRemoveDialog}
                        selectMedicineOrderAddress={selectMedicineOrderAddress}
                        showRemoveOption={false}
                        isRadio={true}
                      />
                    );
                  })}
                  <div className="address-layout-5-middle">
                    <span>Add a new address</span>
                    <button
                      className="address-layout-5-middle-button"
                      onClick={handleAddressAddition}
                    >
                      <img src={nextImg} />
                    </button>
                  </div>
                  <button
                    className="address-layout-5-bottom"
                    onClick={handleBooking}
                    disabled={disabledDeliveryAddress}
                  >
                    {"Continue"}
                  </button>
                </div>
              )}
            </div>
            {openRemoveDialog && (
              <RemoveDialog handleOpenRemoveDialog={handleOpenRemoveDialog} />
            )}
            {showToast && (
              <Toast
                msg={showToast}
                close={() => {
                  dispatch(setStateFromPayloadAddress({ showToast: "" }));
                }}
              />
            )}
          </>
        )}
      </IonContent>
    </IonPage>
  );
}
